var _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _g, _rect, _ellipse4, _ellipse5, _ellipse6, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9501,
    cy: 13.4034,
    rx: 2.36905,
    ry: 2.40338,
    stroke: "#50595F",
    strokeWidth: 1.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7904,
    cy: 14.8454,
    rx: 1.89524,
    ry: 1.9227,
    stroke: "#50595F",
    strokeWidth: 1.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.1095,
    cy: 14.8454,
    rx: 1.89524,
    ry: 1.9227,
    stroke: "#50595F",
    strokeWidth: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3934 26.0923C35.8966 25.8185 36.2144 25.3207 36.2144 24.7732V19.2228C36.2144 18.4015 35.4993 17.7295 34.6253 17.7295H29.275C28.401 17.7295 27.6859 18.4015 27.6859 19.2228V24.7981C27.6859 25.3456 28.0037 25.8434 28.5069 26.1172L28.7453 26.2416C29.0896 26.4159 29.3015 26.7394 29.3015 27.1128V31.6177C29.3015 32.4391 30.0167 33.1111 30.8907 33.1111H33.0096C33.8837 33.1111 34.5988 32.4391 34.5988 31.6177V27.0879C34.5988 26.7145 34.8107 26.391 35.155 26.2168L35.3934 26.0923ZM34.8901 25.7936C34.3869 26.0674 34.0691 26.5652 34.0691 27.1128V31.6177C34.0691 32.1653 33.5923 32.6133 33.0096 32.6133H30.8907C30.308 32.6133 29.8312 32.1653 29.8312 31.6177V27.0879C29.8312 26.5403 29.5134 26.0425 29.0102 25.7687L28.7718 25.6692C28.4275 25.495 28.2156 25.1714 28.2156 24.7981V19.2228C28.2156 18.6753 28.6923 18.2273 29.275 18.2273H34.6253C35.208 18.2273 35.6847 18.6753 35.6847 19.2228V24.7981C35.6847 25.1714 35.4728 25.495 35.1285 25.6692L34.8901 25.7936Z",
    fill: "#50595F",
    stroke: "#50595F",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 25.4078V20.189C41.9 19.365 41.1925 18.6908 40.3279 18.6908H37.8126C37.6553 18.6908 37.5505 18.7907 37.5505 18.9405C37.5505 19.0903 37.6553 19.1902 37.8126 19.1902H40.3279C40.9043 19.1902 41.376 19.6397 41.376 20.189V25.2579L39.9087 26.007C39.8301 26.057 39.7777 26.1319 39.7777 26.2318V30.6515C39.7777 31.2008 39.306 31.6503 38.7296 31.6503H36.4763C36.3191 31.6503 36.2143 31.7502 36.2143 31.9C36.2143 32.0498 36.3191 32.1497 36.4763 32.1497H38.7296C39.5943 32.1497 40.3017 31.4755 40.3017 30.6515V26.3816L41.769 25.6325C41.8476 25.5825 41.9 25.5076 41.9 25.4078Z",
    fill: "#50595F",
    stroke: "#50595F",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8122 25.9935L23.0481 26.1181C23.3887 26.2926 23.5983 26.6166 23.5983 26.9905V30.6543C23.5983 31.4768 24.3057 32.1497 25.1704 32.1497H27.4237C27.5809 32.1497 27.6857 32.05 27.6857 31.9005C27.6857 31.7509 27.5809 31.6512 27.4237 31.6512H25.1704C24.5939 31.6512 24.1223 31.2026 24.1223 30.6543V26.9905C24.1223 26.4421 23.8079 25.9436 23.3101 25.6695L23.0743 25.5449C22.7336 25.3704 22.524 25.0464 22.524 24.6725V20.1862C22.524 19.6379 22.9957 19.1893 23.5721 19.1893H26.0874C26.2446 19.1893 26.3494 19.0896 26.3494 18.94C26.3494 18.7905 26.2446 18.6908 26.0874 18.6908H23.5721C22.7074 18.6908 22 19.3637 22 20.1862V24.6725C22 25.2209 22.3144 25.7193 22.8122 25.9935Z",
    fill: "#50595F",
    stroke: "#50595F",
    strokeWidth: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9501,
    cy: 57.4034,
    rx: 2.36905,
    ry: 2.40338,
    stroke: "url(#paint0_linear_4_103)",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7904,
    cy: 58.8454,
    rx: 1.89524,
    ry: 1.9227,
    stroke: "url(#paint1_linear_4_103)",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.1095,
    cy: 58.8454,
    rx: 1.89524,
    ry: 1.9227,
    stroke: "url(#paint2_linear_4_103)",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3934 70.0923C35.8966 69.8185 36.2144 69.3207 36.2144 68.7732V63.2228C36.2144 62.4015 35.4993 61.7295 34.6253 61.7295H29.275C28.401 61.7295 27.6859 62.4015 27.6859 63.2228V68.7981C27.6859 69.3456 28.0037 69.8434 28.5069 70.1172L28.7453 70.2416C29.0896 70.4159 29.3015 70.7394 29.3015 71.1128V75.6177C29.3015 76.4391 30.0167 77.1111 30.8907 77.1111H33.0096C33.8837 77.1111 34.5988 76.4391 34.5988 75.6177V71.0879C34.5988 70.7145 34.8107 70.391 35.155 70.2168L35.3934 70.0923ZM34.8901 69.7936C34.3869 70.0674 34.0691 70.5652 34.0691 71.1128V75.6177C34.0691 76.1653 33.5923 76.6133 33.0096 76.6133H30.8907C30.308 76.6133 29.8313 76.1653 29.8313 75.6177V71.0879C29.8313 70.5403 29.5134 70.0425 29.0102 69.7687L28.7718 69.6692C28.4275 69.495 28.2156 69.1714 28.2156 68.7981V63.2228C28.2156 62.6753 28.6923 62.2273 29.275 62.2273H34.6253C35.208 62.2273 35.6847 62.6753 35.6847 63.2228V68.7981C35.6847 69.1714 35.4728 69.495 35.1285 69.6692L34.8901 69.7936Z",
    fill: "#50595F",
    stroke: "url(#paint3_linear_4_103)",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9 69.4078V64.189C41.9 63.365 41.1925 62.6908 40.3279 62.6908H37.8126C37.6553 62.6908 37.5505 62.7907 37.5505 62.9405C37.5505 63.0903 37.6553 63.1902 37.8126 63.1902H40.3279C40.9043 63.1902 41.376 63.6397 41.376 64.189V69.2579L39.9087 70.007C39.8301 70.057 39.7777 70.1319 39.7777 70.2318V74.6515C39.7777 75.2008 39.306 75.6503 38.7296 75.6503H36.4763C36.3191 75.6503 36.2143 75.7502 36.2143 75.9C36.2143 76.0498 36.3191 76.1497 36.4763 76.1497H38.7296C39.5943 76.1497 40.3017 75.4755 40.3017 74.6515V70.3816L41.769 69.6325C41.8476 69.5825 41.9 69.5076 41.9 69.4078Z",
    fill: "#50595F",
    stroke: "url(#paint4_linear_4_103)",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8122 69.9935L23.0481 70.1181C23.3887 70.2926 23.5983 70.6166 23.5983 70.9905V74.6543C23.5983 75.4768 24.3057 76.1497 25.1704 76.1497H27.4237C27.5809 76.1497 27.6857 76.05 27.6857 75.9005C27.6857 75.7509 27.5809 75.6512 27.4237 75.6512H25.1704C24.5939 75.6512 24.1223 75.2026 24.1223 74.6543V70.9905C24.1223 70.4421 23.8079 69.9436 23.3101 69.6695L23.0743 69.5449C22.7336 69.3704 22.524 69.0464 22.524 68.6725V64.1862C22.524 63.6379 22.9957 63.1893 23.5721 63.1893H26.0874C26.2446 63.1893 26.3494 63.0896 26.3494 62.94C26.3494 62.7905 26.2446 62.6908 26.0874 62.6908H23.5721C22.7074 62.6908 22 63.3637 22 64.1862V68.6725C22 69.2209 22.3144 69.7193 22.8122 69.9935Z",
    fill: "#50595F",
    stroke: "url(#paint5_linear_4_103)",
    strokeWidth: 0.7
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9501,
    cy: 101.403,
    rx: 2.36905,
    ry: 2.40338,
    stroke: "white",
    strokeWidth: 1.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7904,
    cy: 102.845,
    rx: 1.89524,
    ry: 1.9227,
    stroke: "white",
    strokeWidth: 1.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.1095,
    cy: 102.845,
    rx: 1.89524,
    ry: 1.9227,
    stroke: "white",
    strokeWidth: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3934 114.092C35.8966 113.819 36.2144 113.321 36.2144 112.773V107.223C36.2144 106.401 35.4993 105.729 34.6253 105.729H29.275C28.401 105.729 27.6859 106.401 27.6859 107.223V112.798C27.6859 113.346 28.0037 113.843 28.5069 114.117L28.7453 114.242C29.0896 114.416 29.3015 114.739 29.3015 115.113V119.618C29.3015 120.439 30.0167 121.111 30.8907 121.111H33.0096C33.8837 121.111 34.5988 120.439 34.5988 119.618V115.088C34.5988 114.715 34.8107 114.391 35.155 114.217L35.3934 114.092ZM34.8901 113.794C34.3869 114.067 34.0691 114.565 34.0691 115.113V119.618C34.0691 120.165 33.5923 120.613 33.0096 120.613H30.8907C30.308 120.613 29.8313 120.165 29.8313 119.618V115.088C29.8313 114.54 29.5134 114.043 29.0102 113.769L28.7718 113.669C28.4275 113.495 28.2156 113.171 28.2156 112.798V107.223C28.2156 106.675 28.6923 106.227 29.275 106.227H34.6253C35.208 106.227 35.6847 106.675 35.6847 107.223V112.798C35.6847 113.171 35.4728 113.495 35.1285 113.669L34.8901 113.794Z",
    fill: "#50595F",
    stroke: "white",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 113.408V108.189C41.9 107.365 41.1925 106.691 40.3279 106.691H37.8126C37.6553 106.691 37.5505 106.791 37.5505 106.94C37.5505 107.09 37.6553 107.19 37.8126 107.19H40.3279C40.9043 107.19 41.376 107.64 41.376 108.189V113.258L39.9087 114.007C39.8301 114.057 39.7777 114.132 39.7777 114.232V118.651C39.7777 119.201 39.306 119.65 38.7296 119.65H36.4763C36.3191 119.65 36.2143 119.75 36.2143 119.9C36.2143 120.05 36.3191 120.15 36.4763 120.15H38.7296C39.5943 120.15 40.3017 119.476 40.3017 118.651V114.382L41.769 113.632C41.8476 113.583 41.9 113.508 41.9 113.408Z",
    fill: "#50595F",
    stroke: "white",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8122 113.993L23.0481 114.118C23.3887 114.293 23.5983 114.617 23.5983 114.99V118.654C23.5983 119.477 24.3057 120.15 25.1704 120.15H27.4237C27.5809 120.15 27.6857 120.05 27.6857 119.9C27.6857 119.751 27.5809 119.651 27.4237 119.651H25.1704C24.5939 119.651 24.1223 119.203 24.1223 118.654V114.99C24.1223 114.442 23.8079 113.944 23.3101 113.669L23.0743 113.545C22.7336 113.37 22.524 113.046 22.524 112.673V108.186C22.524 107.638 22.9957 107.189 23.5721 107.189H26.0874C26.2446 107.189 26.3494 107.09 26.3494 106.94C26.3494 106.79 26.2446 106.691 26.0874 106.691H23.5721C22.7074 106.691 22 107.364 22 108.186V112.673C22 113.221 22.3144 113.719 22.8122 113.993Z",
    fill: "#50595F",
    stroke: "white",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_103",
    x: 17.65,
    y: 52.45,
    width: 28.6,
    height: 31.0111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_103",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_103",
    x1: 31.9501,
    y1: 55,
    x2: 31.9501,
    y2: 59.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_103",
    x1: 25.7904,
    y1: 56.9227,
    x2: 25.7904,
    y2: 60.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_103",
    x1: 38.1095,
    y1: 56.9227,
    x2: 38.1095,
    y2: 60.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_103",
    x1: 31.9502,
    y1: 61.7295,
    x2: 31.9502,
    y2: 77.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_103",
    x1: 39.0571,
    y1: 62.6908,
    x2: 39.0571,
    y2: 76.1497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_103",
    x1: 24.8429,
    y1: 62.6908,
    x2: 24.8429,
    y2: 76.1497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.519d1ed8aa496c04eebe179bd0fa030d.svg";
export { ForwardRef as ReactComponent };